var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 72,
    viewBox: "0 0 116 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_52637)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.2,
    height: 72,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.602 71.4658C89.4136 71.4658 115.202 65.8665 115.202 58.9593C115.202 52.0522 89.4136 46.4529 57.602 46.4529C25.7903 46.4529 0.00195312 52.0522 0.00195312 58.9593C0.00195312 65.8665 25.7903 71.4658 57.602 71.4658Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9992 24.5978L80.7364 4.04788C79.8598 2.64716 78.58 1.80029 77.2318 1.80029H37.9666C36.6184 1.80029 35.3386 2.64716 34.462 4.0461L16.1992 24.5996V41.1063H98.9992V24.5978Z",
    stroke: "#041C44",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 30.263C74.9026 27.3954 76.6918 25.0282 78.9112 25.0264H98.9992V57.4306C98.9992 61.2236 96.6232 64.3324 93.6892 64.3324H21.5092C18.5752 64.3324 16.1992 61.2219 16.1992 57.4306V25.0264H36.2872C38.5066 25.0264 40.2958 27.3901 40.2958 30.2576V30.2969C40.2958 33.1645 42.1048 35.48 44.3224 35.48H70.876C73.0936 35.48 74.9026 33.1431 74.9026 30.2755V30.263Z",
    fill: "#FAFAFA",
    stroke: "#041C44",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_52637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.2,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bfa91f9ee8930e4838c490449d8e64e5.svg";
export { ForwardRef as ReactComponent };